import maplibregl from 'maplibre-gl';

const GEOPF_WMTS_PUBLIC='https://data.geopf.fr/wmts';

// Sources
const OrthoImageryOrthophotosSrc = {
  type: 'raster',
  tileSize: 256,
  tiles: [
    `${GEOPF_WMTS_PUBLIC}?&SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=HR.ORTHOIMAGERY.ORTHOPHOTOS&STYLE=normal&TILEMATRIX={z}&TILEMATRIXSET=PM&TILEROW={y}&TILECOL={x}&FORMAT=image/jpeg&TRANSPARENT=true&`
  ],
};
const GeographicalGridSystemeMapsSrc = {
  type: 'raster',
  tileSize: 256,
  tiles: [
    `${GEOPF_WMTS_PUBLIC}?&SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&TILEMATRIX={z}&TILEMATRIXSET=PM&TILEROW={y}&TILECOL={x}&FORMAT=image/png&TRANSPARENT=true&`
  ],
};
const DecoupageAdministratifSrc = {
  type: 'vector',
  tileSize: 512,
  tiles: [
    'https://openmaptiles.geo.data.gouv.fr/data/decoupage-administratif/{z}/{x}/{y}.pbf'
  ],
  promoteId: 'code'
};

// Layers
const OrthoImageryOrthophotosLay = {
  id: 'OrthoImageryOrthophotos',
  type: 'raster',
  source: 'OrthoImageryOrthophotos',
  minzoom: 0,
  paint: {
    'raster-opacity': 0.3
  },
  layout: {
    visibility: 'visible'
  },
};
const GeographicalGridSystemeMapsLay = {
  id: 'GeographicalGridSystemeMaps',
  type: 'raster',
  source: 'GeographicalGridSystemeMaps',
  minzoom: 0,
  paint: {
    'raster-opacity': 0.2
  },
  layout: {
    visibility: 'visible'
  },
};

const AdminExpressLayers = [
  {
    id: 'regions',
    type: 'fill',
    source: 'decoupage',
    'source-layer': 'regions',
    minzoom: 4,
    maxzoom: 6,
    paint: {
      'fill-color': '#18c6c3',
      'fill-opacity': 0.1
    },
  },
  {
    id: 'departements',
    type: 'fill',
    source: 'decoupage',
    'source-layer': 'departements',
    minzoom: 6,
    maxzoom: 8,
    paint: {
      'fill-color': '#1842c6',
      'fill-opacity': 0.1
    },
  },
  {
    id: 'region_labels',
    type: 'symbol',
    source: 'decoupage',
    'source-layer': 'regions',
    minzoom: Number(process.env.VUE_APP_DEFAULT_MIN_ZOOM) || 4,
    maxzoom: 6,
    paint: {
      'text-halo-color': '#FFFFFF',
      'text-halo-width': 1
    },
    layout: {
      'symbol-placement': 'point',
      'text-field': ['get', 'nom'],
      'text-font': ['Open Sans Semi Bold'],
      'text-anchor': 'center',
      'text-justify': 'center',
      'text-offset': [0, 0],
      'text-size': 14,
    }
  },
  {
    id: 'departement_labels',
    type: 'symbol',
    source: 'decoupage',
    'source-layer': 'departements',
    minzoom: 6,
    maxzoom: 8,
    paint: {
      'text-halo-color': '#FFFFFF',
      'text-halo-width': 1
    },
    layout: {
      'symbol-placement': 'point',
      'text-field': ['get', 'nom'],
      'text-font': ['Open Sans Semi Bold'],
      'text-anchor': 'center',
      'text-justify': 'center',
      'text-offset': [0, 0],
      'text-size': 14,
    }
  },
  {
    id: 'commune_limites',
    type: 'line',
    source: 'decoupage',
    'source-layer': 'communes',
    paint: {
      'line-color': '#187CC6',
      'line-width': 2
    }
  },
  {
    id: 'communes',
    type: 'fill',
    source: 'decoupage',
    'source-layer': 'communes',
    paint: {
      'fill-color': '#187CC6',
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        0.4,
        ['boolean', ['feature-state', 'select'], false],
        0.7,
        0.2
      ]
    },
  },
  {
    id: 'commune_labels',
    type: 'symbol',
    source: 'decoupage',
    'source-layer': 'communes',
    minzoom: 6,
    paint: {
      'text-halo-color': '#FFFFFF',
      'text-halo-width': 1
    },
    layout: {
      'symbol-placement': 'point',
      'text-field': ['get', 'nom'],
      'text-font': ['Open Sans Semi Bold'],
      'text-anchor': 'center',
      'text-justify': 'center',
      'text-offset': [0, 0],
      'text-size': 14,
    }
  },
  {
    id: 'departement_limites',
    type: 'line',
    source: 'decoupage',
    'source-layer': 'departements',
    minzoom: 6,
    paint: {
      'line-color': '#1842c6',
      'line-width': 1
    }
  },
  {
    id: 'region_limites',
    type: 'line',
    source: 'decoupage',
    'source-layer': 'regions',
    minzoom: Number(process.env.VUE_APP_DEFAULT_MIN_ZOOM) || 4,
    maxzoom: 6,
    paint: {
      'line-color': '#18c6c3',
      'line-width': 1
    }
  },
];

export default {
  style: {
    version: 8,
    glyphs: 'https://fonts.undpgeohub.org/fonts/{fontstack}/{range}.pbf',
    sources: {
      OrthoImageryOrthophotos: OrthoImageryOrthophotosSrc,
      GeographicalGridSystemeMaps: GeographicalGridSystemeMapsSrc,
      decoupage: DecoupageAdministratifSrc,
    },
    layers: [
      OrthoImageryOrthophotosLay,
      GeographicalGridSystemeMapsLay,
      ...AdminExpressLayers
    ],
  },
  maxZoom: 21,
  minZoom: 4,
  // 'center': null,
  // 'zoom': null,
  bounds: new maplibregl.LngLatBounds(
    process.env.VUE_APP_DEFAULT_MAP_BOUNDS ?
      process.env.VUE_APP_DEFAULT_MAP_BOUNDS.split(',') :
      [[-4.965820, 42.261049], [8.569336, 51.248163]]
  ),
  fitBoundsOptions: {
    minZoom: Number(process.env.VUE_APP_DEFAULT_MIN_ZOOM) || 4,
    maxZoom: Number(process.env.VUE_APP_DEFAULT_MAX_ZOOM) || 21,
  }
};
